export enum UserClientId {
  d2 = 'D2'
}
